const abbreviateAccount = (username, platformName) => {
    switch (platformName) {
        case 'Facebook':
            return `@${username} - FB`;

        case 'Instagram':
            return `@${username} - IG`;

        case 'Twitter':
        case 'X':
            return `@${username} - X`;

        case 'Youtube':
            return `${username} - YT`;

        default:
            return `${username} - ${platformName}`;
    }
};

export default abbreviateAccount;
